import $ from 'jquery';
import React from 'react';
import { string } from 'prop-types';
import createHistory from 'history/createBrowserHistory';
import { getQueryParams } from 'utils/query-param-helpers';
import { attachEnterAsClickDecorator } from 'utils/attachEnterAsClick';
import scrollTo from 'utils/scroll-to';
import Loader from '../loader';
import { initActiveFilters, manageActiveFilters, removeActiveFilterGroup, getActiveFiltersWithValues } from './utils/active-filters';
import { parseQueryString, buildQueryString } from './utils/query-string';
import FiltersLayout from './layouts/FiltersLayout';
import ContactLayout from './layouts/ContactLayout';
import ListingItemsLayout from './layouts/ListingItemsLayout';
import { filterItems, paginateItems, sortItems } from './utils/item-filter';

export default class FilteredListing extends React.Component {
    constructor(props) {
        super(props);

        this.history = createHistory();
        this.state = {
            isLoading: true,
            contentLoading: false,
            data: {
                filterOptions: [],
                contentData: [],
                resources: [],
                settings: {},
                contact: {}
            },
            APIStatus: '',
            APIMessage: '',
            activeFilters: [],
            currentSort: '',
            defaultYear: {},
            currentPage: 0 // page 1 is 0 (array index value)
        };

        this.toggleFilters = this.toggleFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.resetFilterGroup = this.resetFilterGroup.bind(this);
        this.changePage = this.changePage.bind(this);
        this.updateSort = this.updateSort.bind(this);
        this.toggleFocus = this.toggleFocus.bind(this);
    }

    componentWillMount() {
        const newState = { ...this.state };
        const pageData = this.props.rawData.trim();

        // check for JSON data on the page,
        // If it exists then we're getting data from local mock json file
        if (pageData && pageData.length) {
            // convert the page contents to JSON format & set to state
            const jsonPageData = $.parseJSON(pageData);
            this.setData(jsonPageData, newState);

            // hide the loader if we have items from mock JSON page data
            if (jsonPageData.contentData && jsonPageData.contentData.length > 0) {
                newState.isLoading = false;
            }

            newState.activeFilters = initActiveFilters(jsonPageData.filterOptions);

            this.prePopulateFilters(newState);

            // update the app state with new preset filter values
            this.setState(...this.state, newState);
        }
    }

    componentDidMount() {
        const newState = { ...this.state };

        // If the app is still loading then get data from API
        if (this.state.isLoading) {
            // fetch data from API endpoint
            this.fetchItems(this.getApiUrl(), newState);
        }
    }

    componentWillUpdate(newProps, newState) {
        const queryParams = buildQueryString(newState);

        this.history.replace({
            pathname: window.location.pathname,
            search: queryParams
        });

        if (newState.currentPage !== this.state.currentPage) {
            scrollTo(document.body, 0, 200);
        }
    }

    getApiUrl() {
        let url = `/api/${this.props.url}`;

        if (this.props.fullUrl) {
            url = this.props.fullUrl;
        }

        return url;
    }

    setData(data, newState) {
        // set results & settings
        newState.data.contentData = data.contentData;
        newState.data.settings = data.settings;

        // set filters if they exist
        if (data.filterOptions && data.filterOptions.length) {
            newState.data.filterOptions = data.filterOptions;
        }

        // set resources if they exist
        if (data.resources && data.resources.length) {
            newState.data.resources = data.resources;
        }

        // set defaultSortBy if they exist
        if (data.sortByDefault) {
            newState.currentSort = { ...data.sortByDefault };
        }

        // set default year
        if (data.defaultYear) {
            newState.defaultYear = data.defaultYear;
        }

        // set data contact
        if (data.contact) {
            newState.data.contact = data.contact;
        }
    }

    getRequestedYear(newState, defaultYear, queryString) {
        let def = '';
        let url = '';

        defaultYear.map(filter => {
            if (filter.code === newState.defaultYear.code) {
                [def] = filter.values;
            }
            return filter;
        });

        queryString.map(filter => {
            if (filter.code === newState.defaultYear.code) {
                [url] = filter.values;
            }
            return filter;
        });

        if (def !== url) {
            newState.contentLoading = true;
            this.fetchItems(`${this.getApiUrl()}?year=${url}`, newState, false);
        }
    }

    reFetchData(value) {
        const { code } = this.state.defaultYear;
        const forceClear = false;
        const reset = false;

        const newState = {
            ...this.state,
            currentPage: 0,
            focusedFilter: null,
            contentLoading: true,
            activeFilters: manageActiveFilters(this.state.activeFilters, code, value, forceClear)
        };

        this.setState(newState);

        this.fetchItems(`${this.getApiUrl()}?year=${value}`, newState, reset);
    }

    prePopulateFilters(newState) {
        const url = getQueryParams();
        const activeFilters = this.state.activeFilters.length > 0
            ? this.state.activeFilters
            : initActiveFilters(this.state.data.filterOptions);

        // inject currentYear
        if (this.state.activeFilters.length === 0) {
            for (let i = 0; i < activeFilters.length; i += 1) {
                if (activeFilters[i].code === newState.defaultYear.code) {
                    if (activeFilters[i].values.length === 0) {
                        activeFilters[i].values.push(newState.defaultYear.year);
                    }
                }
            }
        }

        // eslint-disable-next-line max-len
        const presetFilters = parseQueryString(url, activeFilters, this.state.currentPage, newState.currentSort, newState.defaultYear);

        if (presetFilters) {
            if (JSON.stringify(presetFilters.activeFilters) !== JSON.stringify(this.state.activeFilters)) {
                this.getRequestedYear(newState, activeFilters, presetFilters.activeFilters);
                newState.activeFilters = presetFilters.activeFilters;
            }

            if (presetFilters.currentSort !== newState.currentSort) {
                newState.currentSort = presetFilters.currentSort;
            }

            if (parseInt(presetFilters.currentPage, 10) !== 0) {
                newState.currentPage = parseInt(presetFilters.currentPage, 10);
            }
        }
    }

    fetchItems(url, newState, reset = true) {
        $.getJSON(url)
            .fail((jqxhr, textStatus, error) => {
                newState.APIStatus = 'error';
                newState.APIMessage = `${textStatus}, ${error}`;
                // update the app state with api error values
                this.setState(...this.state, newState);
            })
            .done(response => {
                this.setData(response.data, newState);

                newState.isLoading = false;

                if (reset) {
                    newState.activeFilters = initActiveFilters(response.data.filterOptions);
                }

                this.prePopulateFilters(newState);

                // update the app state with api data & new preset filter values
                this.setState(...this.state, newState);
            });
    }

    resetFilters(event) {
        event.preventDefault();
        this.setState({
            activeFilters: initActiveFilters(this.state.data.filterOptions),
            currentPage: 0
        });
    }

    resetFilterGroup(groupCode) {
        this.setState({
            activeFilters: removeActiveFilterGroup(this.state.activeFilters, groupCode),
            currentPage: 0
        });
    }

    toggleFilters(evt, filter, value, forceClear = false) {
        this.toggleFocus(filter);
        this.setState({
            activeFilters: manageActiveFilters(this.state.activeFilters, filter.code, value, forceClear),
            currentPage: 0
        });

        // hijack if it GS.year
        if (filter.code === this.state.defaultYear.code) {
            this.reFetchData(value);
        }
    }

    changePage(pageNum) {
        this.setState({ currentPage: pageNum });
    }

    updateSort(sort) {
        this.setState({
            currentSort: sort,
            currentPage: 0
        });
    }

    toggleFocus(filter) {
        this.setState({ focusedFilter: filter ? filter.code : null });
    }

    renderAPIErrorMessage() {
        if (this.state.APIStatus !== 'error') { return null; }

        return (
            <p className="validation-msg">Oops, something went wrong: {this.state.APIMessage}</p>
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div>
                    <Loader />
                    {this.renderAPIErrorMessage}
                </div>
            );
        }

        const { contentData, filterOptions, resources, settings, contact } = this.state.data;
        const { filtersLayout, itemContainerLayout, itemDirection, itemType } = this.props;
        const filterSettingsObj = {
            activeFiltersStyle: settings.activeFiltersStyle ? settings.activeFiltersStyle : 'btn-tags',
            showActiveFilters: settings.showActiveFilters,
            activeFiltersLabel: settings.activeFiltersLabel,
            keywordPlaceholderText: settings.keywordPlaceholderText,
            keywordSearchableFields: settings.keywordSearchableFields
        };
        const activeFilters = getActiveFiltersWithValues(this.state.activeFilters);
        const filteredItems = filterItems(activeFilters, contentData, filterSettingsObj.keywordSearchableFields);
        const sortedItems = sortItems(filteredItems, this.state.currentSort);
        const pagedItems = paginateItems(sortedItems, this.state.currentPage, settings.itemsPerPage);

        const contactData = Object.keys(contact).length > 0 && contact.constructor === Object ? contact : null;

        return (
            <div className={`c-filtered-listing ${filtersLayout} ${this.props.filtersBg}`}>
                <div className="filtered-listing-container">
                    <div className="filtered-listing">
                        <FiltersLayout
                            mainState={this.state}
                            filters={filterOptions}
                            activeFilters={activeFilters}
                            filterSettings={filterSettingsObj}
                            toggleFilters={attachEnterAsClickDecorator(this.toggleFilters)}
                            resetFilters={this.resetFilters}
                            resetFilterGroup={this.resetFilterGroup}
                            focusedFilter={this.state.focusedFilter}
                            toggleFocus={this.toggleFocus}
                        />

                        { contactData !== null &&
                            <ContactLayout
                                contact={contact}
                            />
                        }

                        <ListingItemsLayout
                            contentLoading={this.state.contentLoading}
                            itemWrapperModifier={itemContainerLayout}
                            itemType={itemType}
                            itemDirection={itemDirection}
                            listingItems={pagedItems}
                            resources={resources}

                            showResultCount={settings.showResultCount}
                            itemCount={filteredItems.length}
                            sortBy={settings.sortBy}
                            currentSort={this.state.currentSort}
                            updateSort={this.updateSort}

                            totalPages={Math.ceil(filteredItems.length / settings.itemsPerPage)}
                            itemsPerPage={settings.itemsPerPage}
                            currentPage={this.state.currentPage}
                            changePage={this.changePage}
                            resetFilters={this.resetFilters}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

FilteredListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    url: string,
    fullUrl: string,
    rawData: string,
    itemType: string,
    itemDirection: string,
    itemContainerLayout: string,
    filtersLayout: string,
    filtersBg: string
    /* eslint-enable react/no-typos */
};

FilteredListing.defaultProps = {
    url: '',
    fullUrl: '',
    rawData: '',
    itemType: 'content',
    itemDirection: 'vertical',
    itemContainerLayout: 'four-col',
    filtersLayout: 'filters-top',
    filtersBg: ''
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/index.jsx